import {
  ACTION_DELETE_BB_USER,
  ACTION_DELETE_BB_USER_SUCCESS,
  ACTION_DELETE_BB_USER_FAILURE,
  ACTION_RESET_DELETE_BB_USER,
} from '../configs/ActionTypes';

const initialState = {
  success: null,
  isLoading: false,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_DELETE_BB_USER: {
      return {
        ...state,
        isLoading: true,
        success: null,
      };
    }

    case ACTION_DELETE_BB_USER_SUCCESS: {
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    }

    case ACTION_DELETE_BB_USER_FAILURE: {
      return {
        ...state,
        success: false,
        isLoading: false,
      };
    }

    case ACTION_RESET_DELETE_BB_USER: {
      return initialState;
    }

    default:
      return state;
  }
}
